import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ListaOpcionesInterface } from "../interfaces/ListaOpciones.interface";

export async function ListListaOpcionesAction(
  nombreLista: string
): Promise<ApiResponse<ListaOpcionesInterface>> {
  const { data } = await apiClient.get(`/genListas/${nombreLista}`);
  return {
    status: 200,
    data,
    message: "Lista de opciones obtenida correctamente",
  };
}
